












































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import verifyCode from './VerifyCode.vue'
@Component({
	components: {
		verifyCode
	}
})
export default class LoginForm extends Vue {
	@Prop() private phone!: string
	@Prop ({
		type: Boolean,
		default: true
	}) private logoFlag!: boolean
	private ruleForm: {
		password: string | undefined,
		passwordAgain: string | undefined,
		code: string | undefined,
		verifyImgCode: string | undefined
	} = {
		password: '',
		passwordAgain: '',
		code: '',
		verifyImgCode: ''
	}
	private uuid: string = (this as any).$fxUtils.createUUID()
	private verifyCodeImgUrl: string = ''
	private rules: object = {
		password: [{ validator: this.validatePassword, trigger: 'blur' }],
		passwordAgain: [{ validator: this.validatePasswordAgain, trigger: 'blur' }],
		code: [{ validator: this.validateCode, trigger: 'no' }],
		verifyImgCode: [{ validator: this.validateVerifyImgCode, trigger: 'blur' }]
	}
	private validatePassword (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('请输入密码'))
		} else {
			callback()
		}
	}
	private validatePasswordAgain (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('请再次输入密码'))
		} else if (value !== this.ruleForm.password) {
			callback(new Error('密码不一致'))
		} else {
			callback()
		}
	}
	private validateCode (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('验证码不能为空'))
		} else if (!(this as any).$fxUtils.regVerifyCode().test(value)) {
			callback(new Error('验证码为四位数字'))
		} else {
			callback()
		}
	}
	private validateVerifyImgCode (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('请输入图形验证码'))
		} else {
			callback()
		}
	}
	@Watch('uuid', { immediate: true })
	private onUuidChange (val: any, oldVal: any) {
		this.verifyCodeImgUrl = `/cldEdi/business/${val}/getVerifyCode`
	}
	private refreshVerifyImgCode () {
		this.uuid = (this as any).$fxUtils.createUUID()
		const verifyImgCode = (this as any).$refs.verifyImgCode
		verifyImgCode.select()
	}
	private onResetPasswordClick (ruleForm: string): void {
		(this.$refs[ruleForm] as any).validate().then((valid: any) => {
			this.$emit('on-reset-password', this.ruleForm)
		})
	}
	private onCellInputEnter (arg: any, prop: string): void {
		if (prop === 'submit') {
			this.onResetPasswordClick('ruleForm')
		} else {
			(this.$refs[prop] as any).focus()
		}
	}
	private onLoginClick (): void {
		this.$emit('on-login-click')
	}
	private onRegisterClick (): void {
		this.$emit('on-register-click')
	}
	private beforeVerifyImgCodeClick () {
		let validPass = true
		return new Promise((resolve: any) => {
			(this.$refs.ruleForm as any).validateField(['password', 'passwordAgain', 'verifyImgCode'], (res: any) => {
				if (res) {
					validPass = false
				}
			})
			if (validPass) {
				resolve()
			}
		})
	}
}
